import React, { Component } from "react";
import CommonTemplate from "./commonTemplate";
import Signbutton from "../forms/button";
import { Input } from "../forms/input";
import { connect } from "react-redux";
import { forgotUserId } from "../../store/actions";
import CustomizedDialogs from "../home/customModal";
import Image from "../Image";
class ForgotUserId extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: { value: "" },
      open: false,
    };
  }
  closeModal = () => {
    this.setState({
      open: false,
    });
    this.props.history.push("/");
  };

  keyPress = (e) => {
    if (e.key === "Enter") {
      this.sendUserId();
      e.preventDefault();
    }
  };

  changeValue = (event) => {
    this.setState({
      emailId: { value: event.target.value },
    });
  };

  sendUserId = async () => {
    const {
      emailId: { value },
    } = this.state;

    if (!value) {
      this.emailIdField.focus();
      this.setState({
        emailId: {
          value,
          isError: !value,
          errorMessage: "Email ID is mandatory",
        },
      });
    } else if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)) {
      this.setState({
        emailId: {
          value: "",
          isError: true,
          errorMessage: "Please enter a valid Email ID",
        },
      });
    } else {
      const params = {
        ReqBy: "a",
        Emailid: value,
      };
      const response = await this.props.forgotUserId(params);
      if (!response) {
        this.setState({
          emailId: {
            value: "",
            isError: true,
            errorMessage: "No User ID found with given Email ID",
          },
        });
        return;
      } else if (response) {
        this.setState({ open: true, emailId: { value: "" } });
      }
    }
  };

  render() {
    const { emailId } = this.state;
    return (
      <>
        {/* title="Forgot User ID"
       textOne="Forget User ID"
       textTwo="Please enter your registered Email ID" */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 48,
          }}
        >
          <Image src={"/images/kfinkart-logo.svg"} alt="field_image" />
        </div>
        <div className="form_heading">
          <h2>Forgot User ID?</h2>
        </div>
        <Input
          name={"Email ID"}
          isDark={true}
          bordercolor="#384455"
          className="Input-field-div-dark"
          placeholder={"Email ID"}
          image={"/images/kfin_email.svg"}
          value={emailId.value}
          onChange={this.changeValue}
          onBlur={this.showError}
          errorMessage={emailId.errorMessage}
          isShowError={emailId.isError}
          inputref={(ele) => (this.emailIdField = ele)}
          onKeyPress={this.keyPress}
        />
        <Signbutton
          buttontitle="Submit"
          onClick={this.sendUserId}
          isDark={true}
        />
        <CustomizedDialogs
          open={this.state.open}
          closeModal={this.closeModal}
          passwordSucess={true}
          message={
            "Your UserId has been sent to your Email ID and Mobile number"
          }
        />
        <div className="text-center mt-2">
          <button
            className="login-no-account-span mouse-pointer border-0 mt-2"
            onClick={() => this.props.history.push("/login")}
          >
            Return to signin
          </button>
        </div>
      </>
    );
  }
}

export default connect(null, { forgotUserId })(ForgotUserId);
